import { render } from "./DigitalMemberType.vue?vue&type=template&id=5f127d72"
import script from "./DigitalMemberType.vue?vue&type=script&lang=js"
export * from "./DigitalMemberType.vue?vue&type=script&lang=js"

import "./DigitalMemberType.vue?vue&type=style&index=0&id=5f127d72&lang=css"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__